import React from "react";
import { OtpInput } from "@/components";
import { EMAIL_TYPE, FormatTime, WEB_COLORS } from "@/lib/constants";
import { QueryBuilder } from "@mui/icons-material";
import { Box, Button, FormHelperText, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

function VerifyEmailOtpModalFields({
  error,
  formik,
  timeLeft,
  otpVerifying,
  handleOtpSubmit,
  handleResendOtp,
}) {
  const t = useTranslations("WorkDetails");
  const isWorkEmail = formik.values?.emailType === EMAIL_TYPE.WORK;
  const isPersonalEmail = formik.values?.emailType === EMAIL_TYPE.PERSONAL;
  const displayEmail = isWorkEmail
    ? formik.values.workEmailId
    : formik.values.personalEmailId;
  return (
    <Stack spacing={2} alignItems={"center"} justifyContent={"center"}>
      <Typography variant="h5" color={WEB_COLORS.primary} fontWeight={"bold"}>
        {isPersonalEmail
          ? "Verify Personal Email"
          : isWorkEmail
            ? "Verify Official Email"
            : ""}
      </Typography>
      <Stack justifyContent={"center"} alignItems={"center"}>
        <Typography fontSize={14} color={WEB_COLORS.fadeColor}>
          {"Kindly enter the 4 digit OTP sent to"}
        </Typography>
        <Typography color={WEB_COLORS.primary} variant="h7" fontWeight={"bold"}>
          {displayEmail}
        </Typography>
      </Stack>

      <Box my={3}>
        <OtpInput
          length={4}
          onOtpSubmit={handleOtpSubmit}
          isLoading={otpVerifying}
        />
      </Box>
      {error && (
        <FormHelperText error>
          {error?.message ||
            error?.data?.data?.message ||
            error?.data?.message ||
            ""}
        </FormHelperText>
      )}
      {timeLeft !== 0 ? (
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          px={1}
          spacing={1}
        >
          <Typography variant="span">{t("resendotpin")} </Typography>
          <Stack
            direction={"row"}
            spacing={0.5}
            alignItems={"center"}
            color={"red"}
          >
            <QueryBuilder fontSize="14" />
            <Typography align="center" minWidth={40} maxWidth={40}>
              {FormatTime(timeLeft)}
            </Typography>
          </Stack>
        </Stack>
      ) : (
        <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
          <Typography variant="span">{t("didntrecieveotp")} </Typography>
          <Button
            sx={{
              ml: 1,
              textDecoration: "underline",
              fontWeight: "bold",
            }}
            onClick={handleResendOtp}
          >
            {t("resendotp")}
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

export default VerifyEmailOtpModalFields;
